import { FaExclamationTriangle } from "react-icons/fa";
import "./BrowserNotSupported.css";

const BrowserNotSupported = () => {
  return (
    <div
      className="browser-not-supported-container"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8fafc",
        fontFamily: "Arial, sans-serif",
        padding: "20px",
      }}
    >
      <div
        className="browser-not-supported-card"
        style={{
          maxWidth: "600px",
          width: "100%",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
          padding: "40px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "24px",
          }}
        >
          <FaExclamationTriangle
            style={{
              fontSize: "64px",
              color: "#f59e0b",
            }}
          />
        </div>

        <h1
          style={{
            fontSize: "28px",
            fontWeight: "bold",
            color: "#1f2937",
            marginBottom: "16px",
            lineHeight: "1.2",
          }}
        >
          Browser Not Supported
        </h1>

        <p
          style={{
            fontSize: "18px",
            color: "#6b7280",
            marginBottom: "32px",
            lineHeight: "1.6",
          }}
        >
          We're sorry, but this website doesn't support Internet Explorer or
          Samsung Internet Browser. For the best experience, please use one of
          the modern browsers below.
        </p>

        <div
          style={{
            marginBottom: "32px",
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#374151",
              marginBottom: "20px",
            }}
          >
            Recommended Browsers:
          </h2>

          <div
            className="browser-icons-container"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "24px",
              flexWrap: "wrap",
            }}
          >
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textDecoration: "none",
                color: "#374151",
                padding: "16px",
                borderRadius: "8px",
                transition: "background-color 0.2s",
                minWidth: "100px",
              }}
              onMouseOver={(e) =>
                (e.target.closest("a").style.backgroundColor = "#f3f4f6")
              }
              onMouseOut={(e) =>
                (e.target.closest("a").style.backgroundColor = "transparent")
              }
            >
              <img
                src="/chrome-color-svgrepo-com.svg"
                alt="Chrome"
                style={{
                  width: "40px",
                  height: "40px",
                  marginBottom: "8px",
                }}
              />
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                Chrome
              </span>
            </a>

            <a
              href=""
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textDecoration: "none",
                color: "#374151",
                padding: "16px",
                borderRadius: "8px",
                transition: "background-color 0.2s",
                minWidth: "100px",
              }}
              onMouseOver={(e) =>
                (e.target.closest("a").style.backgroundColor = "#f3f4f6")
              }
              onMouseOut={(e) =>
                (e.target.closest("a").style.backgroundColor = "transparent")
              }
            >
              <img
                src="/firefox-svgrepo-com.svg"
                alt="Firefox"
                style={{
                  width: "40px",
                  height: "40px",
                  marginBottom: "8px",
                }}
              />
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                Firefox
              </span>
            </a>

            <a
              href=""
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textDecoration: "none",
                color: "#374151",
                padding: "16px",
                borderRadius: "8px",
                transition: "background-color 0.2s",
                minWidth: "100px",
              }}
              onMouseOver={(e) =>
                (e.target.closest("a").style.backgroundColor = "#f3f4f6")
              }
              onMouseOut={(e) =>
                (e.target.closest("a").style.backgroundColor = "transparent")
              }
            >
              <img
                src="/edge-svgrepo-com.svg"
                alt="Edge"
                style={{
                  width: "40px",
                  height: "40px",
                  marginBottom: "8px",
                }}
              />
              <span style={{ fontSize: "14px", fontWeight: "500" }}>Edge</span>
            </a>

            {/* Safari */}
            <a
              href=""
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textDecoration: "none",
                color: "#374151",
                padding: "16px",
                borderRadius: "8px",
                transition: "background-color 0.2s",
                minWidth: "100px",
              }}
              onMouseOver={(e) =>
                (e.target.closest("a").style.backgroundColor = "#f3f4f6")
              }
              onMouseOut={(e) =>
                (e.target.closest("a").style.backgroundColor = "transparent")
              }
            >
              <img
                src="/safari-svgrepo-com.svg"
                alt="Safari"
                style={{
                  width: "40px",
                  height: "40px",
                  marginBottom: "8px",
                }}
              />
              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                Safari
              </span>
            </a>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "#f9fafb",
            borderRadius: "8px",
            padding: "20px",
            marginBottom: "24px",
          }}
        >
          <h3
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#374151",
              marginBottom: "8px",
            }}
          >
            Why upgrade your browser?
          </h3>
          <ul
            style={{
              textAlign: "left",
              color: "#6b7280",
              fontSize: "14px",
              lineHeight: "1.5",
              paddingLeft: "20px",
            }}
          >
            <li>Better security and privacy protection</li>
            <li>Faster browsing and improved performance</li>
            <li>Access to modern web features</li>
            <li>Better compatibility with websites</li>
          </ul>
        </div>

        <p
          style={{
            fontSize: "14px",
            color: "#9ca3af",
            marginTop: "24px",
          }}
        >
          Thank you for your understanding. We appreciate your visit!
        </p>
      </div>
    </div>
  );
};

export default BrowserNotSupported;
